import { toast } from 'react-toastify'
import { IoMdCheckmarkCircle, IoMdCloseCircle } from 'react-icons/io'
import { ValidationError } from 'src/context/errors';
import Button from 'src/components/basic/Button';

interface CallToastInputs {
  header?: string;
  footer?: string;
  type?: 'success' | 'error'
}

export const useToast = () => {
  return { callToast }
}

export const callToast = ({ header, footer, type }: CallToastInputs) => toast(
  <div className={`tlie-toast-body-container`}>
    <aside>{type === 'success' ? <IoMdCheckmarkCircle /> : <IoMdCloseCircle />}</aside>
    <main>
      <header>{header}</header>
      <section>{footer}</section>
    </main>
  </div>,
  {
    position: 'top-right',
    autoClose: 5000,
    pauseOnHover: true,
    hideProgressBar: true,
    closeOnClick: false,
    type: type ?? 'success'
  }
)

export const callValidationErrorToast = (errors: ValidationError[], { type }: CallToastInputs) => {
  if (errors.length > 0) {
    document.querySelectorAll(`[data-error-code="${errors[0]?.ErrorCode}"]`)[0]?.scrollIntoView({ behavior: 'smooth', block: "center" })
  }
  const saveLaterButton: any = document.querySelectorAll(`[data-save-later]`)[0]
  const saveContinueButton: any = document.querySelectorAll(`[data-save-continue]`)[0]

  return toast(
    <div className={`tlie-toast-body-container`}>
      <aside>{type === 'success' ? <IoMdCheckmarkCircle /> : <IoMdCloseCircle />}</aside>
      <main>
        <header>Validation Errors</header>
        {

          errors.map((e) => {
            const errorElement = document.querySelectorAll(`[data-error-code="${e.ErrorCode}"]`)[0]
            return (
              <section>
                {
                  errorElement ?
                    <a onClick={() => errorElement.scrollIntoView({ behavior: 'smooth', block: "center" })}>
                      View
                    </a>
                    :
                    <a style={{color: 'white', userSelect: 'none'}}>
                      View
                    </a>
                }
                {e.ErrorMessage}
              </section>
            )
          })
        }
        <footer>
          {/* <Button
            variant="secondary"
            style={{display: 'inline-block', padding: '3px', margin: '10px 15px 0 0'}}
            onClick={() => saveLaterButton?.click()}
          >
            Save for Later
          </Button> */}
          <Button
            variant="primary"
            style={{display: 'inline-block', padding: '3px', margin: '10px 0 0 0'}}
            onClick={() => saveContinueButton?.click()}
          >
            Save & Continue
          </Button>
        </footer>
      </main>
    </div>,
    {
      position: 'top-right',
      autoClose: false,
      pauseOnHover: true,
      hideProgressBar: true,
      closeOnClick: false,
      type: type ?? 'success'
    }
  )
}